import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user.module';
import species from './modules/species.module';
import search from './modules/search.module';
import watchlist from './modules/watchlist.module';
import log from './modules/log.module';
import virtuallog from './modules/virtuallog.module';
import zoho from './modules/zoho.module';
import pallet from './modules/pallet.module';
import {
	HIDE_DIALOG,
	SET_DETAIL_VIEW_BACK_LINK,
	SET_DISPLAY_ADVANCED_SEARCH,
	SET_LOADING,
	SET_LOADING_LOGS,
	MUTATE_SNACK,
	SHOW_DIALOG,
	SET_HEADER_REVEAL,
	SET_SEARCH_TYPE,
	SET_SEARCH_DISPLAY_TYPE,
	SET_SEARCH_DISPLAY_TYPE_PALLET,
	SET_PALLET_LOGS_SEARCH_DISPLAY_TYPE, SET_SEARCH_PARAMS
} from "@/store/mutations.type";
import {
	FETCH_BUNDLES_FOR_LOG,
	FETCH_BUNDLES_FOR_VIRTUAL_LOG,
	RESTORE_LOCAL_STORAGE_DATA,
	SET_SNACK
} from "@/store/actions.type";
import {SearchService, VirtualLogService} from "@/common/api";
import _isObject from 'lodash/isObject';
import {SNACK_LEVEL} from "@/common/constants";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// main component is loading data (blocking operation)
		isLoading: false,
		// loading log records
		loadingLogs: false,
		dialogVisible: false,
		dialogComponent: null,
		dialogPersistent: false,
		dialogCloseButton: true,
		dialogPosition: 'standard',
		dialogFullWidth: false,
		dialogContentClass: '',
		dialogContentStyle: '',
		dialogComponentProps: {},
		dialogTitle: '',
		snack: null,
		snackLevel: SNACK_LEVEL.INFO,
		displayAdvancedSearch: false,
		detailViewBackLink: false,
		headerReveal: true,
		neutral: parseInt(document.body.dataset.neutral) === 1 ? 1 : 0
	},
	getters: {
		isLoading: state => state.isLoading,
		loadingLogs: state => state.loadingLogs,
		snack: state => state.snack,
		snackLevel: state => state.snackLevel,
		displayAdvancedSearch: state => state.displayAdvancedSearch,
		detailViewBackLink: state => state.detailViewBackLink,
		headerReveal: state => state.headerReveal,
		neutral: state => state.neutral
	},
	actions: {
		[FETCH_BUNDLES_FOR_LOG]({commit}, log) {
			return SearchService.getBundles(log.logId || log.intLogId)
				.then(({data}) => {
					return data;
				})
				.catch(error => {
					throw new Error(error);
				})
		},
		[FETCH_BUNDLES_FOR_VIRTUAL_LOG]({commit}, log) {
			return VirtualLogService.getBundles(log.uid)
				.then(({data}) => {
					return data;
				})
				.catch(error => {
					throw new Error(error);
				})
		},
		[SET_SNACK]({commit}, snackParams) {
			commit(MUTATE_SNACK, snackParams);
		},
		[RESTORE_LOCAL_STORAGE_DATA]({commit}) {
			const searchType = localStorage.getItem('searchType'),
				searchDisplayType = localStorage.getItem('searchDisplayType'),
				searchDisplayTypePallet = localStorage.getItem('searchDisplayTypePallet'),
				palletLogSearchDisplayType = localStorage.getItem('palletLogSearchDisplayType');

			if(searchType) {
				commit(SET_SEARCH_TYPE, parseInt(searchType));
				commit(SET_SEARCH_PARAMS, {searchType: searchType});
			}
			if(searchDisplayType) commit(SET_SEARCH_DISPLAY_TYPE, searchDisplayType);
			if(searchDisplayTypePallet) commit(SET_SEARCH_DISPLAY_TYPE_PALLET, searchDisplayTypePallet);
			if(palletLogSearchDisplayType) commit(SET_PALLET_LOGS_SEARCH_DISPLAY_TYPE, palletLogSearchDisplayType);
		}
	},
	mutations: {
		[SET_LOADING](state, isLoading) {
			state.isLoading = isLoading;
		},
		[SET_LOADING_LOGS](state, loading) {
			state.loadingLogs = loading;
		},
		[SHOW_DIALOG](state, payload) {
			const {
				component,
				title,
				persistent,
				closeButton,
				position,
				fullWidth,
				contentClass,
				contentStyle,
				...componentProps
			} = payload;

			state.dialogVisible = true;
			state.dialogComponent = component;
			state.dialogTitle = title;
			state.dialogPersistent = persistent;
			state.dialogCloseButton = closeButton;
			state.dialogPosition = position;
			state.dialogFullWidth = fullWidth;
			state.dialogContentClass = contentClass;
			state.dialogContentStyle = contentStyle;
			state.dialogComponentProps = componentProps;
		},
		[HIDE_DIALOG](state) {
			state.dialogVisible = false;
			state.dialogComponent = null;
			state.dialogTitle = '';
			state.dialogPersistent = false;
			state.dialogCloseButton = true;
			state.dialogPosition = 'standard';
			state.dialogFullWidth = false;
			state.dialogContentClass = '';
			state.dialogContentStyle = '';
			state.dialogComponentProps = {};
		},
		[MUTATE_SNACK](state, snack) {
			if (_isObject(snack)) {
				state.snack = snack.snack;
				state.snackLevel = snack.level;
			} else {
				state.snack = snack;
			}
		},
		[SET_DISPLAY_ADVANCED_SEARCH](state, display) {
			state.displayAdvancedSearch = display;
		},
		[SET_DETAIL_VIEW_BACK_LINK](state, link) {
			state.detailViewBackLink = link;
		},
		[SET_HEADER_REVEAL](state, reveal) {
			// allows forcing the header to be visible after navigating to a page that has no scrolling
			state.headerReveal = reveal;
			// reverts to expected behaviour after using this to make the header visible
			window.setTimeout(() => {
				state.headerReveal = true;
			}, 500);
		}
	},
	modules: {
		user,
		species,
		search,
		watchlist,
		log,
		virtuallog,
		zoho,
		pallet
	}
});